import { formatHoursDurationCompact } from "./formatHoursDurationCompact";

/**
 * Formats travel time for display:
 * - If < 60 minutes: 'X min'
 * - If >= 60 minutes: 'Xh YYm'
 * @param minutes Travel time in minutes
 * @returns Formatted string
 */
export function formatTravelTimeForDisplay(minutes: number): string {
  if (minutes < 60) {
    return `${minutes} min`;
  }

  const hours = minutes / 60;
  return formatHoursDurationCompact(hours);
}
